import { MutationTree } from 'vuex'
import { ILegacyState } from '@/store/legacy'
import { Types, Token, Type, Expired, User } from '@/store/legacy/types'

const mutations: MutationTree<ILegacyState> = {
  [Types.token]: (state, action: Token) => {
    state.accessToken = action.payload
  },

  [Types.type]: (state, action: Type) => {
    state.tokenType = action.payload
  },

  [Types.expired]: (state, action: Expired) => {
    state.expired = action.payload
  },

  [Types.user]: (state, action: User) => {
    state.user = action.payload
  }
}

export default mutations
